(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5364],{

/***/ 39541:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/politica-de-privacidade",
      function () {
        return __webpack_require__(45799);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 50121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Banner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37265);
/* harmony import */ var _bannerDefault_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67202);
/* harmony import */ var _bannerDefault_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_bannerDefault_module_scss__WEBPACK_IMPORTED_MODULE_3__);





function Banner(param) {
    var image = param.image, _children = param.children, children = _children === void 0 ? "" : _children, _width = param.width, width = _width === void 0 ? "100%" : _width, _height = param.height, height = _height === void 0 ? "fit-content" : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_bannerDefault_module_scss__WEBPACK_IMPORTED_MODULE_3___default().bannerContainer),
        style: {
            width: width,
            height: height
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: (image === null || image === void 0 ? void 0 : image.src) || "/img/loading-wall.gif",
                loader: _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_4__/* .customLoader */ .l,
                width: width,
                layout: "fill",
                objectFit: "cover",
                quality: 100,
                alt: "Hype Empreendimentos",
                priority: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_bannerDefault_module_scss__WEBPACK_IMPORTED_MODULE_3___default().childrenContainer),
                children: children
            })
        ]
    });
}


/***/ }),

/***/ 38280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MetaTags; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function MetaTags(param) {
    var data = param.data;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    if (!data) return null;
    var ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, _descricao, ref21, ref22;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
                children: [
                    " ",
                    (ref8 = data === null || data === void 0 ? void 0 : data.titulo) !== null && ref8 !== void 0 ? ref8 : "",
                    " "
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: (ref9 = data === null || data === void 0 ? void 0 : data.descricao) !== null && ref9 !== void 0 ? ref9 : ""
            }, "metadescription"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                itemProp: "name",
                content: (ref10 = data === null || data === void 0 ? void 0 : data.titulo) !== null && ref10 !== void 0 ? ref10 : ""
            }, "googlename"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                itemProp: "description",
                content: (ref11 = data === null || data === void 0 ? void 0 : data.descricao) !== null && ref11 !== void 0 ? ref11 : ""
            }, "googledescription"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                itemProp: "image",
                content: (ref12 = data === null || data === void 0 ? void 0 : (ref = data.imagem) === null || ref === void 0 ? void 0 : ref.url) !== null && ref12 !== void 0 ? ref12 : ""
            }, "googleimage"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: (ref13 = data === null || data === void 0 ? void 0 : data.rota) !== null && ref13 !== void 0 ? ref13 : ""
            }, "ogurl"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }, "ogtype"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: (ref14 = data === null || data === void 0 ? void 0 : data.titulo) !== null && ref14 !== void 0 ? ref14 : ""
            }, "ogtitle"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: (ref15 = data === null || data === void 0 ? void 0 : data.descricao) !== null && ref15 !== void 0 ? ref15 : ""
            }, "ogdesc"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                itemProp: "image",
                content: (ref16 = data === null || data === void 0 ? void 0 : (ref1 = data.imagem) === null || ref1 === void 0 ? void 0 : ref1.url) !== null && ref16 !== void 0 ? ref16 : ""
            }, "image"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                itemProp: "image",
                content: (ref17 = data === null || data === void 0 ? void 0 : (ref2 = data.imagem) === null || ref2 === void 0 ? void 0 : ref2.url) !== null && ref17 !== void 0 ? ref17 : ""
            }, "ogimage"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:width",
                content: (ref18 = data === null || data === void 0 ? void 0 : (ref3 = data.imagem) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.width) === null || ref4 === void 0 ? void 0 : ref4.toString()) !== null && ref18 !== void 0 ? ref18 : ""
            }, "ogimagewidth"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:height",
                content: (ref19 = data === null || data === void 0 ? void 0 : (ref5 = data.imagem) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.height) === null || ref6 === void 0 ? void 0 : ref6.toString()) !== null && ref19 !== void 0 ? ref19 : ""
            }, "ogimageheight"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: "Hype Empreendimentos"
            }, "ogsitename"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: (ref20 = data === null || data === void 0 ? void 0 : data.titulo) !== null && ref20 !== void 0 ? ref20 : ""
            }, "twittertitle"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: (_descricao = data.descricao) !== null && _descricao !== void 0 ? _descricao : ""
            }, "twitterdescription"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: (ref21 = data === null || data === void 0 ? void 0 : (ref7 = data.imagem) === null || ref7 === void 0 ? void 0 : ref7.url) !== null && ref21 !== void 0 ? ref21 : ""
            }, "twitterimage"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:domain",
                content: "hypeempreendimentos.com.br"
            }, "twitterdomain"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:url",
                content: (ref22 = data === null || data === void 0 ? void 0 : data.rota) !== null && ref22 !== void 0 ? ref22 : ""
            }, "twitterurl")
        ]
    });
}


/***/ }),

/***/ 45799:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Privacidade; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_BannerDefault__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50121);
/* harmony import */ var _components_MetaTags__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38280);
/* harmony import */ var _utils_ImageFindSizes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34873);
/* harmony import */ var _politica_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92716);
/* harmony import */ var _politica_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_politica_module_scss__WEBPACK_IMPORTED_MODULE_6__);







var parse = __webpack_require__(30488);
var __N_SSG = true;
function Privacidade(param) {
    var politica = param.politica;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var rota = "https://hypeempreendimentos.com.br".concat(router.asPath);
    if (!politica) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MetaTags__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    data: {
                        titulo: politica === null || politica === void 0 ? void 0 : (ref = politica.seo) === null || ref === void 0 ? void 0 : (ref1 = ref.seo) === null || ref1 === void 0 ? void 0 : ref1.metaTitle,
                        descricao: politica === null || politica === void 0 ? void 0 : (ref2 = politica.seo) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.seo) === null || ref3 === void 0 ? void 0 : ref3.metaDescription,
                        imagem: politica === null || politica === void 0 ? void 0 : (ref4 = politica.seo) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.seo) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.ogImage) === null || ref6 === void 0 ? void 0 : ref6.url,
                        rota: rota
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_BannerDefault__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                image: {
                    src: (0,_utils_ImageFindSizes__WEBPACK_IMPORTED_MODULE_5__/* .imagemSizes */ .xQ)((0,_utils_ImageFindSizes__WEBPACK_IMPORTED_MODULE_5__/* .findImage */ .jw)(politica === null || politica === void 0 ? void 0 : politica.imagens, "banner-principal"))
                },
                width: "100%",
                height: "70vh",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    children: (ref8 = politica === null || politica === void 0 ? void 0 : (ref7 = politica.textos) === null || ref7 === void 0 ? void 0 : ref7.find(function(txt) {
                        return txt.referencia === "politica-de-privacidade-titulo-banner";
                    })) === null || ref8 === void 0 ? void 0 : ref8.texto.conteudo
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_politica_module_scss__WEBPACK_IMPORTED_MODULE_6___default().section),
                children: parse((ref10 = politica === null || politica === void 0 ? void 0 : (ref9 = politica.textos) === null || ref9 === void 0 ? void 0 : ref9.find(function(txt) {
                    return txt.referencia === "politica-de-privacidade-clausulas";
                })) === null || ref10 === void 0 ? void 0 : ref10.texto.conteudo)
            })
        ]
    });
}


/***/ }),

/***/ 34873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "jw": function() { return /* binding */ findImage; },
/* harmony export */   "xQ": function() { return /* binding */ imagemSizes; }
/* harmony export */ });
/* unused harmony export imagemSizeDestructure */
// eslint-disable-next-line import/prefer-default-export
var imagemSizeDestructure = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var data = props === null || props === void 0 ? void 0 : props.imagem;
    if (data === null || data === void 0 ? void 0 : (ref = data.sizes) === null || ref === void 0 ? void 0 : (ref1 = ref.large) === null || ref1 === void 0 ? void 0 : ref1.url) {
        return data.sizes.large;
    }
    if (data === null || data === void 0 ? void 0 : (ref2 = data.sizes) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.medium) === null || ref3 === void 0 ? void 0 : ref3.url) {
        return data.sizes.medium;
    }
    if (data === null || data === void 0 ? void 0 : (ref4 = data.sizes) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.small) === null || ref5 === void 0 ? void 0 : ref5.url) {
        return data.sizes.small;
    }
    if (data === null || data === void 0 ? void 0 : (ref6 = data.sizes) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.square) === null || ref7 === void 0 ? void 0 : ref7.url) {
        return data.sizes.square;
    }
    if (data === null || data === void 0 ? void 0 : (ref8 = data.sizes) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.thumbnail) === null || ref9 === void 0 ? void 0 : ref9.url) {
        return data.sizes.thumbnail;
    }
    if (data === null || data === void 0 ? void 0 : data.url) {
        return data;
    }
    return "";
};
var imagemSizes = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var data = props === null || props === void 0 ? void 0 : props.imagem;
    if (data === null || data === void 0 ? void 0 : (ref = data.sizes) === null || ref === void 0 ? void 0 : (ref1 = ref.large) === null || ref1 === void 0 ? void 0 : ref1.url) {
        return data.sizes.large.url;
    }
    if (data === null || data === void 0 ? void 0 : (ref2 = data.sizes) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.medium) === null || ref3 === void 0 ? void 0 : ref3.url) {
        return data.sizes.medium.url;
    }
    if (data === null || data === void 0 ? void 0 : (ref4 = data.sizes) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.small) === null || ref5 === void 0 ? void 0 : ref5.url) {
        return data.sizes.small.url;
    }
    if (data === null || data === void 0 ? void 0 : (ref6 = data.sizes) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.square) === null || ref7 === void 0 ? void 0 : ref7.url) {
        return data.sizes.square.url;
    }
    if (data === null || data === void 0 ? void 0 : (ref8 = data.sizes) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.thumbnail) === null || ref9 === void 0 ? void 0 : ref9.url) {
        return data.sizes.thumbnail.url;
    }
    if (data === null || data === void 0 ? void 0 : data.url) {
        return data.url;
    }
    return "";
};
var findImage = function(imagens, referencia) {
    return imagens === null || imagens === void 0 ? void 0 : imagens.find(function(img) {
        return img.referencia === referencia;
    });
};


/***/ }),

/***/ 67202:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bannerContainer":"bannerDefault_bannerContainer___FPrj","childrenContainer":"bannerDefault_childrenContainer__kGyT8"};

/***/ }),

/***/ 92716:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"politica_section__NN9w_"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(39541); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);